import "../styles/Hero.css";

export const Hero = () => {
  return (
    <div className="container spacer">
      <div className="col-md-9 mx-auto heading">
        <p className="text-coral" data-aos="fade" data-aos-duration="1000">Hi, my name is</p>
        <h2 className="heading" data-aos="fade-up" data-aos-duration="1000">Erwin Agpasa
          <span className="d-block text-secondary hero-subtitle" data-aos="ease-in" data-aos-duration="2000">I build things for the web and mobile.</span>
        </h2>

        <div className="col-md-8">
          <p className="text-secondary" data-aos="fade" data-aos-duration="2800">
            Full Stack Developer specializing in building scalable web and mobile applications,
            ERP systems, and AI-powered solutions with RAG and workflow automation.
            Currently based in Bahrain.
          </p>
        </div>


      </div>
    </div>
  )
}
